import { render, staticRenderFns } from "./cms-button-group.vue?vue&type=template&id=36cc341c&scoped=true&"
import script from "./cms-button-group.vue?vue&type=script&lang=js&"
export * from "./cms-button-group.vue?vue&type=script&lang=js&"
import style0 from "./cms-button-group.vue?vue&type=style&index=0&id=36cc341c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc341c",
  null
  
)

export default component.exports